import { FILTER_TYPE } from "@wizeoo/akm-core-lib";

/**
 * un objet de configuration de filtre (FilterComponent)
 */
export class FilterObj {

  public f: string; // le champ sur le VO source
  public label: string; // le code du libellé TRADUIT
  public order: number; // ordre d'affichage

  public k: FILTER_TYPE; // le type de filtre désiré (selon le type du field)
  public filterData: any; // les données pour alimentation du compo de rendu de ce filtre
  public filterConstraint: any; // les contraintes à appliquer pour le compo (min , max...)
  public filterFunction: (item: any, filterValue: any) => boolean; // éventuellement une fonction à appeler plutôt qu'un field sur l'objet

  public v: any; // la valeur sélectionnée du filtre

  public compoInstance: any; // alimenté par FilterComponent. Permet l'accès à l'instance de compo de rendu de ce filtre

  /**
   * construction d'un FilterObj
   * @param f le champ sur le VO source
   * @param label le code du libellé (sera traduit)
   * @param k le type de filtre désiré (selon le type du field)
   * @param v la valeur sélectionnée du filtre
   * @param order la position de cette clé de filtre dans la liste des filtres
   * @param filterFunction Une fonction à appeler plutôt que de se baser sur un field du VO.
   *                       Donner une fonction plutôt qu'un field dans le vo permet de filter également en fonction du contexte de la vue.
   *                       Exemple dans la vue des users sur AllkeyDom
   */
  public static create( field: string,
                        label: string,
                        filterType: FILTER_TYPE,
                        filterValue: any = null,
                        order: number = 999,
                        filterFunction?: (item: any, filterValue: any) => boolean): FilterObj {
    const result: FilterObj = new FilterObj();
    result.f = field;
    result.label = label;
    result.k = filterType;
    result.v = filterValue;
    result.order = order;
    result.filterFunction = filterFunction;
    return result;
  }

  /**
   * Alimentation des données pour les filtres à listes ou à restrictions
   * @param filterData les données
   * @param filterConstraint les contraintes
   */
  public setDatas(filterData: any = null, filterConstraint: any = null ): FilterObj {
    this.filterData = filterData;
    this.filterConstraint = filterConstraint;
    return this;
  }

  /**
   * Alimentation des valeurs sélectionnées
   * @param filterValue les valeurs actives
   */
  public setValues(filterValue: any ): FilterObj {
    this.v = filterValue;
    return this;
  }


  /** accesseur sur la value simplifiée pour alimentation du contexte */
  public getMinifyValue(): any {
    switch(this.k) {
      case FILTER_TYPE.LIST_MONO:
      case FILTER_TYPE.LIST_MULTI :
        // TODO optim en lien avec la datasource: trouver la clé, pas forcément CODE
        const res = [];
        if (this.v) {
          this.v.forEach((vo: any) => {
            if (vo) {
              res.push(vo.code); // TODO, identifier la clé
            }
          });
        }
        console.log('filterVals', this.v, res);
        return res;
      break;
      default :
        return this.v;
      break;
    }
  }

}
